import { getKeys, StringMap } from './StringMap';

export type StrictStringMap<T> = StringMap<T | undefined>;

export function getStrictValues<T>(map: StrictStringMap<T>): T[] {
  return getKeys(map).map(key => map[key]!);
}

export function withDefault<S, T>(f: (s: S) => T, t: T, map: StrictStringMap<S>, key: string): T {
  const value = map[key];
  return value !== undefined ? f(value) : t;
}
